import styled from "styled-components";
import cafeInside from "../assets/images/cafe-inside.jpeg";
import insideSpace from "../assets/images/inside-space.jpeg";
import logo from "../assets/images/logo.png";
import desktopBg from "../assets/images/pink-background.png";

export const MainImage = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-image: url(${desktopBg});
  background-size: cover;
  background-position: center;
  z-index: -1;

  @media (max-width: 48rem) {
    position: relative;
    min-height: 80vw;
    background-image: url(${cafeInside});
  }
`;

export const LogoImage = styled.div`
  background-image: url(${logo});
  height: 8vw;
  width: 8vw;
  background-size: contain;
  margin-bottom: 1rem;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 1.5vw;
  left: 4vw;
  transition: transform 1s ease-out;
  cursor: pointer;

  &:hover {
    transform: rotate(360deg);
    transition: transform 4s linear;
  }

  @media (max-width: 48rem) {
    position: relative;
    height: 12rem;
    width: 12rem;
    top: auto;
    left: auto;
  }
`;

export const ImageBg = styled.div`
  width: 100%;
  height: 8.25rem;
  box-sizing: border-box;
  background-image: url(${(props) => props.$image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  padding: ${(props) => props.$padding};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  text-align: center;
  gap: 0.5rem;

  @media (max-width: 48rem) {
    background-image: none;
    padding: 0;
    gap: 1.2rem;
  }
`;

export const BrushStrokeBg = styled.div`
  background-image: url(${(props) => props.$image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  padding: ${(props) => props.$padding};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 0.5rem;

  @media (max-width: 48rem) {
    background-image: none;
    padding: 0;
    gap: 1.2rem;
  }
`;
